import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

export default function ReturnsPage() {
  const navigate = useNavigate()

  useEffect(() => {
    // Redirect to admin returns page with CP2077 styling
    navigate('/admin/returns', { replace: true })
  }, [navigate])

  return null
}
